import { useEffect } from 'react'
import Overlay from '../../d.controllers/HUD/components/Overlay/Overlay'
import LevelResults from '../../d.controllers/HUD/LevelResults'
import ScreenNav from '../../d.controllers/HUD/ScreensNav'
import AmbientLight from '../../e.elements/AmbientLight/AmbientLight'
import BigMenuText from '../../e.elements/BigMenuText/BigMenuText'
import useFadeScenes from '../../plugins/CameraFadePlugin/useFadeScenes'
import { Hud, PerspectiveCamera } from '@react-three/drei'

const SplashSceneElements = () => {
  const navigateTo = useFadeScenes()

  useEffect(() => {
    setTimeout(() => navigateTo(1), 1000)
  }, [])
  return (
    <>
      <AmbientLight />
      <Hud renderPriority={1}>
        <PerspectiveCamera makeDefault position={[0, 0, 10]} />
        <Overlay show>
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/LSS-Icon512x512.png`}
            style={{ width: 150, height: 150, objectFit: 'contain', position: 'relative' }}
          />
        </Overlay>
      </Hud>
    </>
  )
}

export default SplashSceneElements
